import { lazyLoad } from "./components/lazy-load";
import { navigation } from "./components/navigation";
import { customSmoothScroll } from "./components/smooth-scroll";
import { detectAvifWebPSupport } from "./components/detect-avif-webp-support";
import { tabs } from "./components/tabs";
import { animationEach } from "./components/animation-each";
import { parallax } from "./components/parallax";
import { iphoneDetector } from "./components/iphone-detector";

window.addEventListener("DOMContentLoaded", () => {
  iphoneDetector.init();
  lazyLoad.init();
  navigation.init();
  customSmoothScroll.init();
  detectAvifWebPSupport.init();
  tabs.init();
  animationEach.init();
  parallax.init();
});
